<app-loading-spinner></app-loading-spinner>

<app-version-notification></app-version-notification>

<router-outlet></router-outlet>
